import React from 'react';
import { connect } from 'react-redux';
import { makeGetTaskUpdated } from '../../../../../redux/tasks/taskEntities/selectors';
import { useIntl } from 'react-intl';

const ConnectedTaskUpdated = ({ updatedAt }) => {
  const intl = useIntl();

  const timeUpdated = intl.formatDate(updatedAt); // moment(new Date(task?.updatedAt)).format('DD MMM, YYYY')

  return <div className="text-xs text-center">{timeUpdated}</div>;
};

const makeMapStateToProps = () => {
  const getTaskUpdated = makeGetTaskUpdated();
  return (state, props) => ({
    updatedAt: getTaskUpdated(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedTaskUpdated);
